import React from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";

export default function CardCongratulations({ event, joinedCount }) {
    if (!event) return null;

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                <CardContent>
                    <Box
                        sx={{
                            textAlign: "center",
                            p: 4,
                            backgroundColor: "rgba(76, 175, 80, 0.16)",
                            borderRadius: 2,
                            border: "2px solid #4caf50",
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                color: "#4caf50",
                                mb: 2,
                                "& .celebration-emoji": {
                                    display: "inline-block",
                                    animation: "bounce 1s ease-in-out infinite",
                                    "@keyframes bounce": {
                                        "0%, 100%": {
                                            transform: "translateY(0) rotate(0deg)",
                                        },
                                        "25%": {
                                            transform: "translateY(-10px) rotate(-10deg)",
                                        },
                                        "50%": {
                                            transform: "translateY(-5px) rotate(10deg)",
                                        },
                                        "75%": {
                                            transform: "translateY(-10px) rotate(-10deg)",
                                        },
                                    },
                                },
                                "& .celebration-emoji:nth-of-type(2)": {
                                    animationDelay: "0.2s",
                                },
                            }}
                        >
                            <Box component="span" className="celebration-emoji">🎉</Box> Congratulations!{" "}
                            <Box component="span" className="celebration-emoji">🎉</Box>
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            You've successfully invited {joinedCount} people to join!
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            You will receive {event.rewardMonths || 1} month{event.rewardMonths !== 1 ? "s" : ""} of free subscription as a reward.
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}

